/* eslint-disable react/forbid-prop-types */
import { GridWrapper, ColWrapper } from './Styled';

const Grid = GridWrapper;

const Col = ColWrapper;

export { Grid, Col };
